// extracted by mini-css-extract-plugin
export default {"ModalTitle":"ModalTitle_ModalTitle__-NhrV","ModalTitle__Description":"ModalTitle_ModalTitle__Description__LJIOD"};